import { css } from 'linaria';
import { strictBreakpoints } from 'media';

export const wrapperClassName = css`
	& .swiper-wrapper {
		margin-top: 0;
	}
`;
export const btnClassName = css`
	margin-right: 16px;
	${strictBreakpoints.onlyMobile} {
		font-size: 14px !important;
	}
`;
